import { render } from "./FamilyPortal.vue?vue&type=template&id=8dfa7e9c&ts=true"
import script from "./FamilyPortal.ts?vue&type=script&lang=ts&external"
export * from "./FamilyPortal.ts?vue&type=script&lang=ts&external"

import "./FamilyPortal.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__